// By default, Klaro will load the config from  a global "klaroConfig" variable.
// You can change this by specifying the "data-config" attribute on your
// script take, e.g. like this:
// <script src="klaro.js" data-config="myConfigVariableName" />
// You can also disable auto-loading of the consent notice by adding
// data-no-auto-load=true to the script tag.

// TODO :: Changed h1 to h3 in .js
// TODO :: Core-Anpassung .js ".cm-btn" hinzugefügt, ".cm-link" entfernt, aus "a" > "button"

var klaroDomain = window.location.hostname;

var klaroConfig = {
    // You can customize the ID of the DIV element that Klaro will create
    // when starting up. If undefined, Klaro will use 'klaro'.
    elementID: 'klaro',

    // How Klaro should store the user's preferences. It can be either 'cookie'
    // (the default) or 'localStorage'.
    storageMethod: 'cookie',

    // You can customize the name of the cookie that Klaro uses for storing
    // user consent decisions. If undefined, Klaro will use 'klaro'.
    cookieName: '__klaro.360-magazine.de',

    //cookieDomain: '.gerrits-macbook',

    // You can also set a custom expiration time for the Klaro cookie.
    // By default, it will expire after 120 days.
    cookieExpiresAfterDays: 120,

    // You can change to cookie domain for the consent manager itself.
    // Use this if you want to get consent once for multiple matching domains.
    // If undefined, Klaro will use the current domain.
    //cookieDomain: '.github.com',

    // Put a link to your privacy policy here (relative or absolute).
    privacyPolicy: 'datenschutz',

    // Defines the default state for applications (true=enabled by default).
    default: false,

    // If "mustConsent" is set to true, Klaro will directly display the consent
    // manager modal and not allow the user to close it before having actively
    // consented or declines the use of third-party apps.
    mustConsent: false,

    // Show "accept all" to accept all apps instead of "ok" that only accepts
    // required and "default: true" apps
    acceptAll: true,

    // replace "decline" with cookie manager modal
    hideDeclineAll: true,

    // You can define the UI language directly here. If undefined, Klaro will
    // use the value given in the global "lang" variable. If that does
    // not exist, it will use the value given in the "lang" attribute of your
    // HTML tag. If that also doesn't exist, it will use 'en'.
    //lang: 'en',

    // You can overwrite existing translations and add translations for your
    // app descriptions and purposes. See `src/translations/` for a full
    // list of translations that can be overwritten:
    // https://github.com/KIProtect/klaro/tree/master/src/translations

    // Example config that shows how to overwrite translations:
    // https://github.com/KIProtect/klaro/blob/master/src/configs/i18n.js
    translations: {
        // If you erase the "consentModal" translations, Klaro will use the
        // bundled translations.
        de: {
            consentModal: {
                title: 'Einstellungen zum Datenschutz',
                description:
                    'Auf dieser Website werden Daten wie z. B. Cookies gespeichert, um wichtige Funktionen der Website, einschließlich Analysen, Marketingfunktionen und Personalisierung zu ermöglichen. Die Einstellungen können jederzeit angepasst oder alle Cookies akzeptiert werden.',
                privacyPolicy: {
                    name: 'Datenschutzerklärung',
                    text: 'Weitere Details in unserer {privacyPolicy}',
                }
            },
            consentNotice: {
                changeDescription: 'Es gab Änderungen seit Deinem letzten Besuch, bitte aktualisiere Deine Auswahl.',
                description: 'Auf dieser Website werden Daten wie z. B. Cookies gespeichert, um wichtige Funktionen der Website, einschließlich Analysen, Marketingfunktionen und Personalisierung zu ermöglichen. Die Einstellungen können jederzeit angepasst oder alle Cookies akzeptiert werden.',
                learnMore: 'Anpassen'
            },
            acceptSelected: 'Auswahl speichern',
            app: {
                disableAll: {
                    description: 'Alle Anwendungen aktivieren/deaktivieren.'
                },
                required: {
                    title: '(erforderlich)'
                }
            },

            requiredCookies: {
                description: 'Technisch notwendige Cookies ermöglichen grundlegende Funktionen der Webseite und können nicht deaktiviert werden.',
            },
            adobeFonts: {
                description: 'Zur einheitlichen Darstellung werden Web-Schriftarten von Adobe verwendet',
            },
            googleAnalytics: {
                description: 'Um die Seite fortlaufend zu verbessern, analysieren wir das Verhalten der Besucher mit Google Analytics',
            },
            facebookPixel: {
                description: 'Analyse des Besucherstatistiken mit dem Facebook Pixel',
            },

            purposes: {
                required: 'Technisch notwendig',
                marketing: 'Marketing',
                personalization: 'Personalisierung',
                analytics: 'Analyse'
            },

        },
    },

    // This is a list of third-party apps that Klaro will manage for you.
    apps: [
        {
            name: 'requiredCookies',
            title: 'Technisch notwendige Cookies',
            purposes: ['required'],
            required: true
        },
        {
            name: 'googleAnalytics',
            title: 'Google Analytics',
            cookies: [
                ['_ga', '/', '.' + klaroDomain],
                ['_gid', '/', '.' + klaroDomain],
                [/^_ga_.*$/i, '/', '.' + klaroDomain],
                [/^_gat_.*$/i, '/', '.' + klaroDomain],
                [/^_gac_.*$/i, '/', '.' + klaroDomain],
                [/^_gac_.*$/i, '/', '.' + klaroDomain]
            ],
            purposes: ['analytics', 'marketing'],
        }
    ],
};
